export default __webpack_public_path__ + "static/media/course1.a3f46bd5.webp";